import {Component, OnInit} from '@angular/core';
import {interval, Subscription} from "rxjs";
import {GlobalLoaderService} from "../../../services/global-loader.service";

@Component({
    selector: 'logzy-global-loader',
    templateUrl: './global-loader.component.html',
    styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit {

    values: string[] = ['Saving data', 'Please wait', 'Almost there', 'Fetching information'];
    currentValue: string = '';
    imgClass: string[] = ['', '', 'road-bump', 'floating-image'];
    currentImageClass = '';
    images: string[] = ['containers', 'container-truck', 'truck', 'cargo-ship']
    currentImage: string = '';
    isReady: boolean = true; // Initial value
    private subscription: Subscription | undefined;

    constructor(public loaderService: GlobalLoaderService) {

    }

    ngOnInit() {
        this.startValueInterval();
    }

    ngOnDestroy() {
        this.stopValueInterval();
    }

    startValueInterval() {
        this.subscription = interval(4000) // 2.5 seconds
            .subscribe(() => {
                this.isReady = false; // Set to false before selecting a new value
                setTimeout(() => {
                    this.currentValue = this.getRandomDifferentValue(); // Get a random value
                    this.currentImage = this.getValueImageClass(); // Get a random value
                    switch (this.currentImage) {
                        case 'truck':
                            this.currentImageClass = 'road-bump';
                            break;
                        case 'cargo-ship':
                            this.currentImageClass = 'floating-image';
                            break;
                        case 'container-truck':
                            this.currentImageClass = 'pendulum';
                            break;
                        default:
                            this.currentImageClass = '';
                            break;
                    }
                    this.isReady = true; // Reset to true after 100 ms
                }, 1);
            });
    }

    getRandomDifferentValue(): string {
        let randomValue: string;
        do {
            const randomIndex = Math.floor(Math.random() * this.values.length);
            randomValue = this.values[randomIndex];
        } while (randomValue === this.currentValue); // Ensure it's different from the current value
        return randomValue;
    }

    imgIndex = 0

    getValueImageClass() {
        let setValue: string;
        setValue = this.images[this.imgIndex]
        this.imgIndex++;
        if (this.imgIndex >= this.images.length) {
            this.imgIndex = 0;
        }
        // console.log('test', setValue)
        return setValue;

    }

    stopValueInterval() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
